import { Dispatch, useEffect } from 'react'
import { TablePOSAction } from '../../hooks/useSaleSelectReducer/useSaleSelectReducer'
import { useSaleDependenciesContext } from '../../contexts/SaleDependenciesContext'
import { getSelectedMenuOrDefault } from 'store/utils/normalizeDependencyData'

export function useSelectDefaultMenu(dispatch: Dispatch<TablePOSAction>) {
    const { isReady, menus, terminalMenu } = useSaleDependenciesContext()
    useEffect(() => {
        if (isReady) {
            const selectedMenu = getSelectedMenuOrDefault(
                menus,
                '',
                terminalMenu,
            )!

            dispatch({
                type: 'SELECT_MENU',
                payload: {
                    selectedMenu,
                },
            })
        }
    }, [dispatch, terminalMenu, menus, isReady])
}
